<template>
  <div>
    <div class="banner">
      <img src="@/assets/2026/r1.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r2.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r3.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r4.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r5.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r6.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r7.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/r8.jpg">
    </div>
  </div>
</template>
<script>
export default {
  name: 'RightNews'
}
</script>
<style lang="scss" scoped>
.news {
  overflow: hidden;

  .iframe-1 {
    border: 0;
    height: 1670px;
    margin-top: -270px;
    pointer-events: none;
    overflow: hidden;
  }
}

@media screen and (max-width: 600px) {
  .news {
    margin-top: 15px;
    .iframe-1 {
      margin-top: -350px;
      height: 1350px;
    }
  }
}
</style>
